import * as yup from 'yup';

import validateCreateContentPlacement from '../validateCreateContentPlacement';

export default yup.object().shape({
  placements: yup.array().nullable().of(validateCreateContentPlacement),
});
